import { ISort } from 'services/BackendApi';
import { IPagination } from 'store/common/types';
import { ECrmDirectoryEntryType, ICrmPerson } from './DirectoryEntry';
import { ICodeValue } from './types';
import { TCurrencyCode } from 'interfaces';

export type TNotificationsSortField = 'date';

export interface INotificationSearchRequest {
  filter?: INotificationSearchFilter;
  pagination: IPagination;
  sort?: ISort<TNotificationsSortField>;
}

export interface INotificationSearchFilter {
  /** Format: date-time */
  startDate?: string;
  /** Format: date-time */
  endDate?: string;
  read?: boolean;
  eventType?: ENotificationEventType;
  directoryEntryFullName?: string;
}

export interface INotificationSearchResponse {
  pagination: IPagination;
  count: number;
  list: INotification[];
}

export interface INotification {
  id: string;
  viewed: boolean;
  read: boolean;
  event: IEvent;
  referencedDirectoryEntries?: IReferencedDirectoryEntryArrayItemSimple[];
}

export interface IEvent {
  id: string;
  type: ENotificationEventType;
  date: string;
  payload: IBookingEventPayload | IUserEventPayload;
}

export interface IBookingEventPayload {
  /** Format: uuid */
  bookingId: string;
  bookingHumanReadableId: string;
  bookingCurrencyCode: TCurrencyCode | null;
  bookingSalesCostCents: number | null;
  bookingPurchaseCostCents: number | null;
};

export interface IBasketEventPayload {
  basketHumanReadableId: string;
  basketCurrencyCode: TCurrencyCode | null;
  basketItemTotalAmountCents: number | null;
};

export interface IUserEventPayload {
  beUser: ICrmPerson;
}

export enum ENotificationEventType {
  BOOKING_REQUESTED = 'BOOKING_REQUESTED',
  BOOKING_CONFIRMED = 'BOOKING_CONFIRMED',
  USER_LOGIN_TA = 'USER_LOGIN_TA',
  NEW_BASKET_ITEM = 'NEW_BASKET_ITEM',
}

export interface IReferencedDirectoryEntryArrayItemSimple {
  /** Format: uuid */
  id: string;
  fullName: string;
  contactType: ICodeValue | null;
  companyType: ICodeValue | null;
}

export interface IGetUnviewedNotificationsCountResponse {
  count: number;
}

export const isBookingEventPayload = (payload: IBookingEventPayload | IUserEventPayload | IBasketEventPayload): payload is IBookingEventPayload => {
  return 'bookingId' in payload;
}

export const isUserEventPayload = (payload: IBookingEventPayload | IUserEventPayload | IBasketEventPayload): payload is IUserEventPayload => {
  return 'beUser' in payload;
}

export const isBasketEventPayload = (payload: IBookingEventPayload | IUserEventPayload | IBasketEventPayload): payload is IBasketEventPayload => {
  return 'basketHumanReadableId' in payload;
}

export interface IBulkChangeNotificationsStatusRequest {
  startDate: string;
  endDate: string;
  read?: boolean;
  viewed?: boolean;
}

export interface IChangeNotificationStatusRequest {
  notificationId: string;
  read?: boolean;
  viewed?: boolean;
}

export interface IExportNotificationsRequest {
  filter?: INotificationSearchFilter;
  sort?: ISort<TNotificationsSortField>;
}

export interface IExportNotificationsSuccessResponse {
  signedUrl: string;
}

export interface IExportNotificationsErrorResponse {
  message: string;
  errorCode: string;
}

export interface ISubscribeToDirectoryEntryRequest {
  beUserId: string;
}

export interface ISubscribeToDirectoryEntryResponse {
  count: number;
  subscribers: ICrmPerson[];
}
